import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export interface ModelState {
  modelId: string | null
  isPreferencesLoaded: boolean
}

/** Keyed by dashboardId. Partial forces TS to narrow absent keys to undefined. */
export type ModelRootState = Partial<Record<string, ModelState>>

function ensureInstance(state: ModelRootState, dashboardId: string): ModelState {
  if (!state[dashboardId]) {
    state[dashboardId] = { modelId: null, isPreferencesLoaded: false }
  }
  return state[dashboardId] as ModelState
}

export const modelSlice = createSlice({
  name: "dashboard/model",
  initialState: {} as ModelRootState,
  reducers: {
    setModelId(
      state,
      action: PayloadAction<{ dashboardId: string, modelId: string | null }>,
    ) {
      const { dashboardId, modelId } = action.payload
      const instance = ensureInstance(state, dashboardId)
      instance.modelId = modelId
    },

    setPreferences(
      state,
      action: PayloadAction<{ dashboardId: string, modelId?: string | null }>,
    ) {
      const { dashboardId, modelId } = action.payload
      const instance = ensureInstance(state, dashboardId)
      if (modelId !== undefined) {
        instance.modelId = modelId
      }
      instance.isPreferencesLoaded = true
    },
  },
})

export default modelSlice.reducer
